import React from 'react'

const ScrollIcon = () => (
    <div className="scrollContainer">
        <div className="chevron"></div>
        <span className="scrolltext">Scroll Down</span>
    </div>
)

export default ScrollIcon